module.exports = __webpack_public_path__ + "img/au.1afd018a.svg";